<i
  class="fas fa-bars d-block d-md-none burguer-button"
  (click)="toggleShowSidebar()"
></i>
<nav
  class="nh-navbar d-md-block"
  [ngClass]="{ 'd-none': !toggleSidebar, 'nh-navbar-open': toggleSidebar }"
>
  <div [ngClass]="{ 'd-none': !toggleSidebar }" class="d-md-none">
    <img
      class="close-button"
      src="../../../assets/images/sidebar/exit-ic.svg"
      alt="close menu"
      (click)="toggleShowSidebar()"
    />
  </div>
  @for (menu of sidebarElements; track menu) {
    <ul class="nh-navbar-nav">
      <li class="w-100 align-content-center logo-sidebar-item col-6 col-md-4">
        <a
          [routerLink]="homeSection"
          class="d-flex logo-link-section"
          (click)="logoSelected()"
        >
          <img
            class="logo-sidebar-image"
            src="../../../assets/images/gallery/portal-logo.svg"
            alt="Lab4U Portal"
          />
          <h3
            [ngClass]="{ 'd-none': !toggleSidebar }"
            class="logo-sidebar-title my-auto pl-2 d-md-none"
          >
            Portal
          </h3>
        </a>
      </li>
      @for (submenu of menu.submenu; track submenu) {
        <li class="nh-nav-item align-content-center d-flex">
          @if (!submenu.outside) {
            <a
              class="nh-nav-link mx-auto"
              [routerLink]="submenu.url"
              (click)="leftSidebarSelected(submenu.url)"
            >
              <img
                class="menu-icon"
                src="{{ submenu.icono }}"
                routerLinkActive="active"
              />
              <p class="d-md-none menu-text my-auto">{{ submenu.titulo }}</p>
              <span class="nh-link-tooltip">{{ submenu.titulo }}</span>
            </a>
          } @else {
            <a
              class="nh-nav-link mx-auto"
              href="{{ submenu.url }}"
              target="_blank"
              (click)="supportSelected()"
            >
              <img class="menu-icon" src="{{ submenu.icono }}" />
              <p class="d-md-none menu-text my-auto">{{ submenu.titulo }}</p>
              <span class="nh-link-tooltip">{{ submenu.titulo }}</span>
            </a>
          }
        </li>
      }
    </ul>
  }
</nav>

<!-- ============================================================== -->
<!-- End Left Sidebar  -->
<!-- ============================================================== -->
